module.exports = __webpack_public_path__ + "img/noimage.01037541.svg";